import { Helmet } from "react-helmet-async";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import NavBar from "../components/NavBar";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState("");


    const handleBack = () => {
        navigate(-1); // Go back to the previous page
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();

        setError("");
        setSuccess("");

        if (!email.trim()) {
            setError("Please enter your email address.");
            return;
        }

        setIsSubmitting(true);

        try {
            await sendPasswordResetEmail(auth, email);

            setSuccess(
                "Password reset email sent successfully. Please check your inbox and spam folder."
            );

            // Optional: Clear the email field
            setEmail("");

            // Redirect after 3 seconds
            setTimeout(() => {
                navigate("/shop-login");
            }, 3000);
        } catch (err) {
            console.log(err);

            switch (err.code) {
                case "auth/invalid-email":
                    setError("Please enter a valid email address.");
                    break;

                case "auth/user-not-found":
                    // Optional: for security you can show a generic message instead.
                    setError("No account found with this email.");
                    break;

                case "auth/too-many-requests":
                    setError("Too many requests. Please try again later.");
                    break;

                default:
                    setError("Unable to send reset email. Please try again.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-full bg-[#f8f8fa] flex flex-col font-['Plus_Jakarta_Sans',sans-serif]">
            <Helmet>
                <title>Forgot Password - Signet Print</title>
            </Helmet>
            <NavBar isLoging={true} />
            <main className="flex-1 flex items-center justify-center p-[16px] md:p-[40px]">

                <div className="w-full max-w-[420px]">

                    {/* HEADER */}
                    <div className="text-center mb-[32px]">
                        <h1 className="font-semibold text-[28px] text-[#212326] mb-[8px]">
                            Reset Password
                        </h1>

                        <p className="font-medium text-[15px] text-[#717182] leading-[1.6]">
                            Enter the email address associated with your store account and we'll send you a reset link.
                        </p>
                    </div>

                    {/* FORM */}
                    <form
                        onSubmit={handleForgotPassword}
                        className="bg-white rounded-[16px] border border-[#e4e5e7] p-[24px] md:p-[32px] flex flex-col gap-[20px]"
                    >

                        {/* ERROR */}
                        {error && (
                            <p className="text-center text-red-600 text-sm font-semibold">
                                {error}
                            </p>
                        )}
                        {success && (
                            <p className="text-[13px] font-medium text-green-700 leading-5">
                                {success}
                            </p>
                        )}

                        {/* EMAIL */}
                        <div className="flex flex-col gap-[6px]">
                            <label className="font-semibold text-[14px] text-[#212326]">
                                Email
                            </label>

                            <div className="relative">
                                <svg className="absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" strokeWidth="2">
                                    <rect width="20" height="16" x="2" y="4" rx="2" />
                                    <path d="m22 7-10 5L2 7" />
                                </svg>

                                <input
                                    type="email"
                                    placeholder="shop@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323]"
                                />
                            </div>
                        </div>

                        {/* SUBMIT */}
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="flex items-center justify-center gap-[8px] w-full h-[48px] rounded-[12px] font-semibold text-[15px] bg-[#ff5323] text-white hover:bg-[#e64a1f] shadow-[0px_2px_8px_rgba(255,83,35,0.25)]"
                        >
                            {isSubmitting ? "Sending..." : "Send Reset Link"}

                            {!isSubmitting && (
                                <svg className="w-[16px] h-[16px]"
                                    xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            )}
                        </button>

                        {/* BACK LINK STYLE */}
                        <button
                            type="button"
                            onClick={handleBack}
                            class="flex items-center justify-center gap-[6px] font-medium text-[13px] text-[#717182] hover:text-[#212326] transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left w-[14px] h-[14px]">
                                <path d="m12 19-7-7 7-7"></path>
                                <path d="M19 12H5"></path>
                            </svg>
                            Back to login
                        </button>

                    </form>
                </div>
            </main>
        </div>
    )
}

export default ForgotPassword;

